// Import necessary modules and components
import React from "react";
import { InviteUsertoOrganizationForm } from "../../Components/OrganizationSettings/UserManagement/InviteOrganizationUsers";
import { useState, useEffect } from "react";
import Loader from "../../Components/Shared/Loader/loader";
import { getOrganizationUsers } from "../../API/Organization/organization";
import NoAccessComponent from "../../Components/Shared/Error/NoAccess";

// Define the WorkspaceInviteUsersPage component and accept the organizationData prop
const WorkspaceInviteUsersPage = ({ organization, user, role }) => {
    // Define the loading, roles, and organizationUsers states using the useState hook
    const [loading, setLoading] = useState(true);
    const authorized = role.roleType === "Owner" || role.roleType === "Administrator"; // Check if the user is authorized

    // Define the roles state and set it to an array of three objects
    const [roles, setRoles] = useState([]);

    // Define organizationUsers states and set them to empty arrays
    const [organizationUsers, setOrganizationUsers] = useState([]);

    const [showNoAccess, setShowNoAccess] = useState(!authorized || false); // Define the showNoAccess state and set it to false

    // Define an useEffect hook that is called when the organizationData prop changes
    useEffect(() => {
        // Define an asynchronous function that fetches the necessary data
        const getOrganizationUsersData = async () => {

            const organizationUsers = await getOrganizationUsers(organization._id);
            const roles = getOrganizationRoles();
            // Set the roles, and organizationUsers states with the retrieved data
            setRoles(roles);
            setOrganizationUsers(organizationUsers);
            // Set the loading state to false since data has been retrieved
            setLoading(false);
        };
        if (authorized) {
            getOrganizationUsersData();
        }
    }, [organization]);

    const getOrganizationRoles = () => {
        let { roles } = organization;
        const filteredRoles = roles.filter((role) => role.roleType !== 'Owner');
        const sortedRoles = filteredRoles.sort((a, b) => a.order - b.order);
        return sortedRoles;
    };

    const postMessage = (data) => {
        window.parent.postMessage(JSON.stringify(data), process.env.REACT_APP_RUNTIME_URL);
    }

    const showNotification = (message) => {
        postMessage({ showNotificationMessage: message });
    }

    const handleCloseDialog = () => {
        postMessage({ closeInvitetoWorkspaceDialog: true });
    }

    // If the user is not an owner or administrator, return a message that they do not have permission to invite users
    if (!authorized) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                <div class="alert alert-danger" role="alert">
                    You do not have permission to invite users to this workspace
                </div>
            </div>
        )
    }

    // If loading is true, show a skeleton UI using the WorkspaceSettingsSkeleton component
    if (loading) return <Loader />;

    if (showNoAccess) {
        return <NoAccessComponent />
    }

    // Otherwise, return the InviteUsertoOrganizationForm component with the necessary props
    return (
        <InviteUsertoOrganizationForm
            organization={organization}
            userRole={role.roleType}
            user={user}
            orgRole={roles}
            organizationUsers={organizationUsers}
            showInIframe={true}
            toUpdateUser={null}
            closeDialog={handleCloseDialog}
            showNotification={showNotification}
        />
    )
}

// Export the WorkspaceInviteUsersPage component
export default WorkspaceInviteUsersPage;